import React from 'react';
import { setComment } from './feedbacks-actions';
import styles from './comment-input.module.scss';
import { AutoHeightTextArea } from 'tradera-components/form-controls/auto-height-text-area';

const _CommentInput = ({ className = '', dispatch, value, transactionId }) => {
    return (
        <AutoHeightTextArea
            className={`form-control ${className} ${styles.commentInput}`}
            text={value}
            onKeyPress={evt => {
                if (evt.key === 'Enter') {
                    evt.preventDefault();
                }
            }}
            onChange={evt => {
                dispatch(setComment(transactionId, evt.target.value));
            }}
        />
    );
};

export const CommentInput = React.memo(_CommentInput);
